import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-timer-component',
  standalone: true,
  imports: [TranslateModule, DatePipe],
  templateUrl: './timer-component.component.html',
  styleUrls: ['./timer-component.component.scss']
})
export class TimerComponentComponent implements OnInit, OnDestroy {

  @Input() lastReadTime!: string | Date;
  @Input() interval!: number;

  elapsedTime = '';
  isOverThreshold = false;

  private intervalId: any;

  ngOnInit() {
    if (!this.lastReadTime) return;

    const start = new Date(this.lastReadTime);
    this.updateTimer(start);
    this.intervalId = setInterval(() => this.updateTimer(start), 1000);
  }

  private updateTimer(startTime: Date): void {
    const now = new Date();
    const diff = now.getTime() - startTime.getTime();

    const seconds = Math.floor(diff / 1000) % 60;
    const minutes = Math.floor(diff / (1000 * 60)) % 60;
    const hours = Math.floor(diff / (1000 * 60 * 60)) % 24;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    const pad = (n: number) => n.toString().padStart(2, '0');
    const parts: string[] = [];

    if (days > 0) parts.push(`${days}d`);
    if (hours > 0 || days > 0) parts.push(`${pad(hours)}h`);
    if (minutes > 0 || hours > 0 || days > 0) parts.push(`${pad(minutes)}m`);
    parts.push(`${pad(seconds)}s`);

    this.elapsedTime = parts.join(' ');

    const intervalMinutes = (this.interval ?? 999999);
    const thresholdMs = 3 * intervalMinutes * 60 * 1000;
    this.isOverThreshold = diff > thresholdMs;
  }


  ngOnDestroy() {
    clearInterval(this.intervalId);
  }
}
